module.exports = __webpack_public_path__ + "img/rob-pro.78dcce21.jpg";